<template>
  <div v-if="visible">
    <div @mousewheel.prevent @click.self="close" class="seal-modal"></div>
    <div class="seal-dialog">
      <div class="top">
        <span class="title">电子签章</span>
        <span @click="close" class="closeIcon">x</span>
      </div>
      <div class="check">
        <div v-if="isSuccess">
          <div class="check-icon_succ-deal"></div>
          <div class="check-text">
            验签成功
          </div>
        </div>
        <div v-else>
          <div class="check-icon-deal"></div>
          <div class="check-text">
            验签失败
          </div>
        </div>
      </div>
      <div class="tab" v-if="false">
        <div
          class="tab-head"
          :class="showInfo ? 'tab-head_active' : ''"
          @click="changeTab(true)"
        >
          验签信息
        </div>
        <div
          v-if="form.length != 0 || !isSuccess"
          class="tab-head"
          :class="showInfo ? '' : 'tab-head_active'"
          @click="changeTab(false)"
        >
          篡改信息
        </div>
        <div v-show="showInfo" class="tab-body">
          <div v-for="(val, key) in res.baseInfo" :key="key" class="clearfix">
            <label class="kg-label">{{ infoMap[key] }}:</label
            ><span class="kg-value">{{ val }}</span>
          </div>
        </div>
        <div v-show="!showInfo" class="tab-body">
          <div class="info-item">{{ res.message }}</div>
          <div v-for="(item, index) in form" :key="index" class="info-item">
            <div>{{ item.protectName }}由:{{ item.origin }}</div>
            <div class="biangen">变更为:{{ item.change }}</div>
          </div>
        </div>
      </div>
      <div class="footer">
        <button @click="close">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
import "../nuo-seal/css/style.css"
export default {
  props: {
    show: false,
    isSuccess: false
  },
  watch: {
    show(val) {
      this.visible = val
      const dom = document.querySelector(`div[bh-paper-pile-dialog-role="bhPaperPileDialogFooter"]`)
      if (dom) {
        dom.style.display = val ? 'none' : 'block'
      }
    },
  },
  data: function () {
    return {
      showInfo: true,
      visible: this.show,
      infoMap: {
        userName: "用户名称",
        mainBody: "签署主体",
        sealName: "签章名称",
        signTime: "签署时间",
      },

      res: {
        isSuccess: true,
      },
      form: [],
    }
  },
  methods: {
    close: function () {
      this.$emit('update:show', false)
      this.res = {
        isSuccess: true,
        message: "",
      }
    },
    changeTab: function (boo) {
      this.showInfo = boo
    },
  },
}
</script>
<style scoped>
.seal-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #000000;
  opacity: 0.5;
  z-index: 9999;
}
.seal-dialog {
  position: fixed;
  top: calc(50% - 300px);
  left: calc(50% - 400px);
  width: 550px;
  height: 300px;
  background-color: #fff;
  z-index: 9999;
}
.seal-dialog .top {
  position: relative;
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #e8e8e8;
}
.seal-dialog .top span {
  position: absolute;
  line-height: 50px;
}
.seal-dialog .top .title {
  left: 24px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
.seal-dialog .top .closeIcon {
  right: 24px;
  font-size: 18px;
  color: #bfbfbf;
  cursor: pointer;
}

.check-text {
  width: 50%;
  text-align: center;
  margin: 0 auto;
  margin-top: 20px;
  font-size: 18px;
  color: #666666;
}
.footer {
  position: absolute;
  bottom: 30px;
  right: 20px;
}
.footer button {
  border: none;
  margin-right: 15px;
  width: 72px;
  height: 32px;
  border-radius: 3px;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  background-color: #fff;
  color: #666666;
  border: 1px solid #d9d9d9;
}
.tab {
  width: 720px;
  margin: 0 auto;
  display: table;
}
.tab-head {
  position: relative;
  display: inline-block;
  width: 109px;
  height: 33px;
  background: #f7f8fa;
  border: 1px solid rgba(0, 0, 0, 0.09);
  text-align: center;
  line-height: 33px;
}
.tab-head_active::after {
  content: "";
  height: 2px;
  width: 60px;
  background: #307bf6;
  position: absolute;
  bottom: 0;
  left: calc(50% - 30px);
}
.tab-body {
  width: 728px;
  height: 257px;
  background: #f7f8fa;
  border: 1px solid rgba(0, 0, 0, 0.09);
  padding: 20px;
  word-break: break-all;
  overflow-y: auto;
}
.info-item {
  margin-top: 10px;
}
.biangen {
  margin-top: 10px;
}
.kg-label {
  float: left;
  text-align: right;
}
.kg-value {
  float: left;
  max-width: 84%;
  text-align: left;
  word-break: break-all;
}
.clearfix {
  margin-top: 10px;
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}
</style>
